import React, { useState } from 'react';

const ROWS = [
  { feature: 'AI / LLM Engineering',       jsdb: true,  freelance: false, bigco: 'partial' },
  { feature: 'Azure Cloud Expertise',       jsdb: true,  freelance: false, bigco: true },
  { feature: 'End-to-end Product Delivery', jsdb: true,  freelance: 'partial', bigco: true },
  { feature: 'Fixed-price Transparency',    jsdb: true,  freelance: true,  bigco: false },
  { feature: 'Start in < 1 week',           jsdb: true,  freelance: true,  bigco: false },
  { feature: 'Dedicated Senior Engineers',  jsdb: true,  freelance: 'partial', bigco: false },
  { feature: 'Post-launch SLA & support',   jsdb: true,  freelance: false, bigco: true },
  { feature: 'Startup-friendly pricing',    jsdb: true,  freelance: true,  bigco: false },
  { feature: 'Multi-country team',          jsdb: true,  freelance: false, bigco: true },
  { feature: 'Own product experience',      jsdb: true,  freelance: false, bigco: false },
];

const tick = (v, highlight) => {
  if (v === true)       return <span className="ct-yes" style={highlight ? { color: '#00B14F' } : {}}>✓</span>;
  if (v === false)      return <span className="ct-no">✗</span>;
  if (v === 'partial')  return <span className="ct-part">◐</span>;
  return null;
};

export default function CompareTable() {
  const [hovered, setHovered] = useState(null);

  return (
    <section className="compare-sec" aria-label="Comparison table">
      <div className="wrap">
        <div className="sec-hd rv">
          <div className="chip">⚖️ Why JSDevBrains</div>
          <h2>How We Stack Up</h2>
          <p>Honestly comparing ourselves to the alternatives — so you can make the right call.</p>
        </div>

        <div className="cmp-wrap rv">
          <table className="cmp-table" aria-label="Feature comparison">
            <thead>
              <tr>
                <th className="cmp-th-feat">Feature</th>
                <th className="cmp-th cmp-th-us">
                  <div className="cmp-us-badge">⭐ Best Choice</div>
                  JSDevBrains
                </th>
                <th className="cmp-th">Freelancers</th>
                <th className="cmp-th">Large Agency</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r, i) => (
                <tr
                  key={r.feature}
                  className={`cmp-tr ${hovered === i ? 'hov' : ''}`}
                  onMouseEnter={() => setHovered(i)}
                  onMouseLeave={() => setHovered(null)}
                >
                  <td className="cmp-feat">{r.feature}</td>
                  <td className="cmp-td cmp-td-us">{tick(r.jsdb, true)}</td>
                  <td className="cmp-td">{tick(r.freelance, false)}</td>
                  <td className="cmp-td">{tick(r.bigco, false)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="cmp-legend">
            <span><span className="ct-yes">✓</span> Yes</span>
            <span><span className="ct-part">◐</span> Partial / Varies</span>
            <span><span className="ct-no">✗</span> No</span>
          </div>
        </div>

        <div className="cmp-cta rv">
          <p>Ready to work with a team that genuinely delivers?</p>
          <a href="#contact" className="btn btn-green" onClick={e => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({behavior:'smooth'}); }}>
            🚀 Start a Project
          </a>
        </div>
      </div>
    </section>
  );
}
